import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.state';
import { loadAllExceptionsAccess } from 'src/app/roles/_shared-by-role/global-settings/store/global-settings.actions';
import { selectAllExceptions } from 'src/app/roles/_shared-by-role/global-settings/store/global-settings.selectors';

@Injectable({
  providedIn: 'root',
})
export class ExceptionsService {
  exceptionsIds: string[] = [];

  constructor(private store: Store<AppState>) {
    this.store.dispatch(loadAllExceptionsAccess());
    this.store.select(selectAllExceptions).subscribe((ids) => {
      // Feature disabled: Exceptions
      // Set the ids params when Exceptions feature is enabled.
      
      this.exceptionsIds = [];
    });
  }

  hasUserExceptionAccess(userId: string | undefined | null): boolean {
    // Feature disabled: Exceptions
    // This method determines if a user has exception access in templates.

    // return !!userId && this.exceptionsIds.includes(userId);
    return false;
  }
}
